import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';
import Bizmachine from '@gef-ui/material-icons/Bizmachine';
import Bullhorn from '@gef-ui/material-icons/Bullhorn';
import Fire from '@gef-ui/material-icons/Fire';
import Heart from '@gef-ui/material-icons/Heart';
import LightbulbOn from '@gef-ui/material-icons/LightbulbOn';
import PersonRegular from '@gef-ui/material-icons/PersonRegular';
import UserGroupRegular from '@gef-ui/material-icons/UserGroupRegular';

import { getLeadsFromMarketPlace } from 'features/views/dashboard/statistics/selectors';

export const LeadsFromMarketPlace = () => {
	const leadsFromMarketPlace = useSelector(getLeadsFromMarketPlace);

	const iconSx = { color: 'primary.main' };

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container>
					<Grid size={4}>
						<Stack direction="row" spacing={2}>
							<Typography variant="body1">{getMessage('dashboard:statistics.inMarketPlace')}</Typography>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.marketplace')}>
									<Box>
										<Fire sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography variant="body1">{leadsFromMarketPlace?.leadCountInMarketplace}</Typography>
							</Stack>
						</Stack>
					</Grid>

					<Grid size={8}>
						<Grid container>
							<Grid size={2}>
								<Typography variant="body1">{getMessage('dashboard:statistics.assigned')}</Typography>
							</Grid>
							<Grid size={10}>
								<Stack
									direction="row"
									sx={{
										justifyContent: 'space-around',
									}}
								>
									<Stack direction="row" spacing={0.5}>
										<Tooltip title={getMessage('dashboard:statistics.leadTypes.leadFromWeb')}>
											<Box>
												<Bullhorn sx={iconSx} />
											</Box>
										</Tooltip>
										<Typography variant="body1">
											{leadsFromMarketPlace?.leadCountLeadFromWebAssigned}
										</Typography>
									</Stack>
									<Stack direction="row" spacing={0.5}>
										<Tooltip
											title={getMessage('dashboard:statistics.leadTypes.businessOpportunity')}
										>
											<Box>
												<LightbulbOn sx={iconSx} />
											</Box>
										</Tooltip>
										<Typography variant="body1">
											{leadsFromMarketPlace?.leadCountBusinessOpportunityAssigned}
										</Typography>
									</Stack>
									<Stack direction="row" spacing={0.5}>
										<Tooltip title={getMessage('dashboard:statistics.leadTypes.life')}>
											<Box>
												<Heart sx={iconSx} />
											</Box>
										</Tooltip>
										<Typography variant="body1">
											{leadsFromMarketPlace?.leadCountLifeAssigned}
										</Typography>
									</Stack>
									<Stack direction="row" spacing={0.5}>
										<Tooltip
											title={getMessage('dashboard:statistics.leadTypes.portfolioOpportunity')}
										>
											<Box>
												<UserGroupRegular sx={iconSx} />
											</Box>
										</Tooltip>
										<Typography variant="body1">
											{leadsFromMarketPlace?.leadCountPortfolioOpportunityAssigned}
										</Typography>
									</Stack>
									<Stack direction="row" spacing={0.5}>
										<Tooltip
											title={getMessage('dashboard:statistics.leadTypes.acquisitionsContacts')}
										>
											<Box>
												<PersonRegular sx={iconSx} />
											</Box>
										</Tooltip>
										<Typography variant="body1">
											{leadsFromMarketPlace?.leadCountAcquisitionsContactsAssigned}
										</Typography>
									</Stack>
									<Stack direction="row" spacing={0.5}>
										<Tooltip
											title={getMessage('dashboard:statistics.leadTypes.businessOpportunitySME')}
										>
											<Box>
												<Bizmachine sx={iconSx} />
											</Box>
										</Tooltip>
										<Typography variant="body1">
											{leadsFromMarketPlace?.leadCountSMEAssigned}
										</Typography>
									</Stack>
								</Stack>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default LeadsFromMarketPlace;
